import { FC } from 'react';
import HeaderBreadCrumb from 'components/HeaderBreadCrumb';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import Deviations from 'components/Pens/Detail/Deviations';
import GrowthMap from 'components/Pens/Detail/GrowthMap';
import ScoreMap from 'components/Pens/Detail/ScoreMap';
import Robot from 'components/Pens/Detail/Robot';
import NoteInfo from 'components/Pens/Detail/NoteInfo';
import './PenDetailPage.scss';

const PenDetailPage: FC = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  return (
    <div className="pen-detail-wrapper">
      <HeaderBreadCrumb
        items={[
          {
            label: t('Pen'),
          },
          {
            label: `${t('Pen ')} ${id}`,
          },
        ]}
      />
      <div className="pen-detail">
        <div className="left-section">
          <Deviations />
          <GrowthMap />
          <ScoreMap />
        </div>
        <div className="right-section">
          <Robot />
          <NoteInfo />
        </div>
      </div>
    </div>
  );
};

export default PenDetailPage;
